import { BC_PROCESS_NAMES } from './bcProcessNames';

export const BC_DEFAULT_PROCESS = BC_PROCESS_NAMES.ACCU_ROD;
